import React, { ReactElement, useEffect, useState } from 'react'

import Button from '@instabox/internal-web-ui/components/Button'
import Input from '@instabox/internal-web-ui/components/Input'
import { useHistory } from 'react-router'

import { areCredentialsValid, clearCredentials, getCredentials, setCredentials } from '../utils/auth'

function Login(): ReactElement | null {
  const history = useHistory()

  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<boolean>(false)
  const [username, setUsername] = useState<string>('')
  const [password, setPassword] = useState<string>('')

  const checkCredentials = async (): Promise<void> => {
    const valid = await areCredentialsValid(username, password)

    if (!valid) {
      setError(true)
      return
    }

    setCredentials(username, password)
    history.push('/baseline')
  }

  useEffect(() => {
    const credentials = getCredentials()

    if (credentials === null) {
      setLoading(false)
      return
    }

    areCredentialsValid(credentials.username, credentials.password)
      .then((valid) => {
        if (valid) {
          history.replace('/baseline')
          return
        }

        clearCredentials()
        setLoading(false)
      })
      .catch(console.error)
  }, [history])

  if (loading) {
    return null
  }

  return (
    <div>
      <Input
        id="username"
        label="username"
        required
        onChange={(e) => {
          setUsername(e.target.value)
        }}
      />
      <Input
        id="password"
        type="password"
        label="password"
        required
        onChange={(e) => {
          setPassword(e.target.value)
        }}
      />
      {error && <p className="mb-3">Something went wrong</p>}

      <Button
        onClick={() => {
          checkCredentials().catch(console.error)
        }}
      >
        Login
      </Button>
    </div>
  )
}

export default Login
